// extracted by mini-css-extract-plugin
module.exports = {"block":"EditCompanyPage_block__UBHlc","root":"EditCompanyPage_root__16O7F","buttons":"EditCompanyPage_buttons__2SGmb","link":"EditCompanyPage_link__39bJ5"};